import { render, staticRenderFns } from "./ItemGol6m.vue?vue&type=template&id=43906996&scoped=true&"
import script from "./ItemGol6m.vue?vue&type=script&lang=js&"
export * from "./ItemGol6m.vue?vue&type=script&lang=js&"
import style0 from "./ItemGol6m.vue?vue&type=style&index=0&id=43906996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43906996",
  null
  
)

export default component.exports